/* eslint-disable no-underscore-dangle */
import { logError } from 'commons/logger';

const handleInsightsPurchaseEvent = ({ hit = {}, cart = [] }) => {
  if (
    window.aa &&
    window.algoliaInitialized &&
    hit &&
    cart.some(
      item =>
        item.product_id === hit?.objectID || item.product_id === hit?.product_id
    )
  ) {
    const product = cart.find(
      item =>
        item.product_id === hit.objectID || item.product_id === hit.product_id
    );
    window.aa('purchasedObjectIDsAfterSearch', {
      eventName: 'Purchase After Search',
      userToken: window?.rudderanalytics?.getAnonymousId?.() || '',
      index: 'products_jb4',
      objectIDs: [hit.objectID],
      queryId: hit.__queryID,
      objectData: [
        {
          name: product?.name,
        },
      ],
      value: product?.price || 0,
      currency: 'USD',
    });
  } else {
    logError('Algolia Insights not initialized yet.');
  }
};

export default handleInsightsPurchaseEvent;
